import { createElement, type ComponentType } from "react"
import { createRoot } from "react-dom/client"

import { Dashboard } from "../dashboard/Dashboard"
import { Guides } from "../guides/Guides"
import { PlaybookTemplates } from "../playbook_templates/PlaybookTemplates"
import { AboutGuestsSection } from "../stays/AboutGuestsSection"
import { BookingSummaryModal } from "../stays/BookingSummaryModal"
import { CelebrationsSection } from "../stays/CelebrationsSection"
import { GuestHospitalitySection } from "../stays/GuestHospitalitySection"
import { StayAssignmentsSection } from "../stays/StayAssignmentsSection"
import { StayNotes } from "../stays/StayNotes"
import { FindVacations } from "../vacations/FindVacations"
import { Waiters } from "../waiters/Waiters"
import { initPostHog } from "../shared/posthog"

void initPostHog()

const components: Record<string, ComponentType<Record<string, unknown>>> = {
  AboutGuestsSection: AboutGuestsSection as unknown as ComponentType<Record<string, unknown>>,
  BookingSummaryModal: BookingSummaryModal as unknown as ComponentType<Record<string, unknown>>,
  CelebrationsSection: CelebrationsSection as unknown as ComponentType<Record<string, unknown>>,
  Dashboard: Dashboard as unknown as ComponentType<Record<string, unknown>>,
  FindVacations: FindVacations as unknown as ComponentType<Record<string, unknown>>,
  GuestHospitalitySection: GuestHospitalitySection as unknown as ComponentType<Record<string, unknown>>,
  Guides: Guides as unknown as ComponentType<Record<string, unknown>>,
  PlaybookTemplates: PlaybookTemplates as unknown as ComponentType<Record<string, unknown>>,
  StayAssignmentsSection: StayAssignmentsSection as unknown as ComponentType<Record<string, unknown>>,
  StayNotes: StayNotes as unknown as ComponentType<Record<string, unknown>>,
  Waiters: Waiters as unknown as ComponentType<Record<string, unknown>>,
}

document.querySelectorAll<HTMLElement>("[data-react-component]").forEach((element) => {
  const componentName = element.dataset.reactComponent
  if (!componentName) return

  const Component = components[componentName]
  if (!Component) return

  createRoot(element).render(createElement(Component, parseProps(element.dataset.reactProps)))
})

function parseProps(propsJson?: string) {
  if (!propsJson) return {}

  return JSON.parse(propsJson) as Record<string, unknown>
}
